export default "__VITE_ASSET__BhyhHhVu__"